export default class ClearAnswerSearchResult {
  constructor(context) {
    this.context = context;
  }

  run() {
    this.context.stores.snippetSearchResult.remove();
  }
}
